import MultiSwitchDisclosure from "@pathwright/ux/src/components/form/MultiSwitchDisclosure"
import { TipStatus } from "../../../tips/types"
import useTipStatus from "../../../tips/useTipStatus"

// For viewing Home tips regardless of conditions.
function HomeSuperUserAugmentationTips() {
  const tips = [
    {
      field: "home-welcome-all-transitional-blank-slate",
      label: "Welcome All Transitional Blank Slate",
      preference: useTipStatus("home-welcome-all-transitional-blank-slate")
    },
    {
      field: "home-welcome-designer-blank-slate",
      label: "Welcome Designer Blank Slate",
      preference: useTipStatus("home-welcome-designer-blank-slate")
    },
    {
      field: "home-welcome-member-blank-slate",
      label: "Welcome Member Blank Slate",
      preference: useTipStatus("home-welcome-member-blank-slate")
    },
    {
      field: "home-set-aside-paths",
      label: "Set Aside Paths",
      preference: useTipStatus("home-set-aside-paths")
    }
  ] as const

  // Early return if any tip is still loading.
  if (tips.some(({ preference }) => preference[2])) return null

  const multiOptions = tips.map(({ field, label, preference }) => ({
    field,
    label,
    value: getValue(preference[0])
  }))

  function getValue(status?: TipStatus) {
    return !!status && status !== "dismissed"
  }

  return (
    <MultiSwitchDisclosure
      singularOption={{
        icon: "info-circle",
        field: "toggle_tips",
        label: "Toggle Tips"
      }}
      multiOptions={multiOptions}
      onSubmit={(values) => {
        tips.forEach(({ field, preference: [, setStatus] }) => {
          setStatus(values[field] ? "expanded" : "dismissed")
        })
      }}
    />
  )
}

export default HomeSuperUserAugmentationTips
